"use client";

import { ReactNode } from 'react';
import { motion, Variants } from 'framer-motion';
import { cn } from '@/lib/utils';

// Направления появления элемента
type RevealDirection = 'up' | 'down' | 'left' | 'right';

// Смещение по оси в зависимости от направления
const directionOffset: Record<RevealDirection, { x?: number; y?: number }> = {
  up: { y: 40 },
  down: { y: -40 },
  left: { x: 40 },
  right: { x: -40 },
};

// Строим варианты анимации для заданного направления
function buildVariants(direction: RevealDirection): Variants {
  const offset = directionOffset[direction];
  return {
    hidden: {
      opacity: 0,
      filter: 'blur(10px)',
      ...offset,
    },
    visible: {
      opacity: 1,
      filter: 'blur(0px)',
      x: 0,
      y: 0,
    },
  };
}

interface ScrollRevealProps {
  children: ReactNode;
  className?: string;
  // Направление появления
  direction?: RevealDirection;
  // Задержка перед началом анимации (в секундах)
  delay?: number;
  // Порог видимости элемента в viewport (0–1)
  amount?: number;
  // Отступ от края viewport
  margin?: string;
}

export function ScrollReveal({
  children,
  className,
  direction = 'up',
  delay = 0,
  amount = 0.3,
  margin = '0px 0px -200px 0px',
}: ScrollRevealProps) {
  const variants = buildVariants(direction);

  return (
    <motion.div
      className={cn(className)}
      variants={variants}
      initial="hidden"
      whileInView="visible"
      viewport={{ amount, margin }}
      transition={{
        duration: 0.7,
        delay,
        ease: [0.25, 0.1, 0.25, 1],
      }}
    >
      {children}
    </motion.div>
  );
}
